import React, { useEffect, useState } from 'react';
import {
    Box,
    Typography,
    IconButton,
    Chip,
    Dialog,
    Fade,
} from '@mui/material';
import { getUserCTAHistory } from "../../service/insights";

import {
    Close as CloseIcon, SelfImprovement as YogaIcon, CalendarMonth as AppointmentIcon,Podcasts as PodcastIcon,DirectionsRun as ActivityIcon, 
    ForumRounded as ConverseIcon, MoodRounded as MoodIcon, FavoriteRounded as GratitudeIcon,GraphicEqRounded as MusicIcon, 
    SpaRounded as SoundTherapyIcon,
} from '@mui/icons-material';
   const formatActivityDate = (date) => {
    const d = new Date(date);

    return d.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
    });
};
const activityConfig = {
    yoga: {
        label: 'Yoga Video',
        accent: '#7C3AED',
        softBg: '#F5F3FF',
        icon: <YogaIcon sx={{ fontSize: 15 }} />,
    },

    appointment: {
        label: 'Appointment',
        accent: '#0891B2',
        softBg: '#ECFEFF',
        icon: <AppointmentIcon sx={{ fontSize: 15 }} />,
    },

    podcast: {
        label: 'Podcast',
        accent: '#0EA5E9',
        softBg: '#E0F2FE',
        icon: <PodcastIcon sx={{ fontSize: 15 }} />,
    },

    activity: {
        label: 'Activity',
        accent: '#059669',
        softBg: '#ECFDF5',
        icon: <ActivityIcon sx={{ fontSize: 15 }} />,
    },

    converse: {
        label: 'Converse',
        accent: '#DC2626',
        softBg: '#FEF2F2',
        icon: <ConverseIcon sx={{ fontSize: 15 }} />,
    },

    mood: {
        label: 'Mood Check-in',
        accent: '#F59E0B',
        softBg: '#FFFBEB',
        icon: <MoodIcon sx={{ fontSize: 15 }} />,
    },

    gratitude: {
        label: 'Gratitude Journal',
        accent: '#EC4899',
        softBg: '#FCE7F3',
        icon: <GratitudeIcon sx={{ fontSize: 15 }} />,
    },

    careMusic: {
        label: 'Care Music',
        accent: '#8B5CF6',
        softBg: '#F3E8FF',
        icon: <MusicIcon sx={{ fontSize: 15 }} />,
    },

    soundTherapy: {
        label: 'Sound Therapy',
        accent: '#14B8A6',
        softBg: '#CCFBF1',
        icon: <SoundTherapyIcon sx={{ fontSize: 15 }} />,
    },
};
const InsightsHistoryDialog = ({
    open,
    onClose,
    selectedActivity,
    timeFilter,
}) => {

    const [rows, setRows] = useState([]);
const [loading, setLoading] = useState(false);
const eventMap = {
    yoga: 'yoga',
    appointment: 'appointment-created',
    activity: 'Quick action',
    converse: 'converse',
    mood: 'mood_checkin',
    gratitude: 'gratitude_journal',
    careMusic: 'care',
    soundTherapy: 'sound_therapy',
    podcast: 'podcast',
};

useEffect(() => {

    const fetchHistory = async () => {

        if (!open || !selectedActivity) return;

        try {

            setLoading(true);

            const user = JSON.parse(localStorage.getItem('user') || '{}');

            const eventName = eventMap[selectedActivity];
            const today = new Date();

let fromDate = new Date();

if (timeFilter === 'daily') {

    fromDate.setDate(today.getDate() - 1);

} else if (timeFilter === 'weekly') {

    fromDate.setDate(today.getDate() - 7);

} else {

    fromDate.setMonth(today.getMonth() - 1);
}

           const response = await getUserCTAHistory(
    user.id,
    eventName,
    fromDate.toISOString().split('T')[0],
    today.toISOString().split('T')[0]
);

            setRows(response.data || []);

        } catch (error) {

            console.error('Failed to fetch CTA history:', error);

        } finally {

            setLoading(false);
        }
    };

    fetchHistory();

}, [open, selectedActivity]);
    return (


<Dialog
    
   open={open}
    onClose={() => onClose()}
    PaperProps={{
    sx: {
        width: { xs: '92%', sm: 430 },
        maxWidth: '430px',
        borderRadius: '24px',
        p: 2.2,
        background: 'linear-gradient(180deg, #ffffff 0%, #fafafe 100%)',
        boxShadow: '0 20px 60px rgba(15,23,42,0.18)',
    }
}}
>
    {selectedActivity && (() => {

        const cfg = activityConfig[selectedActivity] || {
            label: 'Activity',
            accent: '#688cbf',
            softBg: '#F8FAFC',
            icon: <ActivityIcon sx={{ fontSize: 15 }} />,
        };
    

        return (
            <>
                {/* Header */}
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        mb: 3,
                    }}
                >
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.2 }}>
                        <Box
                            sx={{
                                width: 42,
                                height: 42,
                                borderRadius: '14px',
                                background: cfg.softBg,
                                color: cfg.accent,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            {cfg.icon}
                        </Box>

                        <Typography
                            sx={{
                                fontWeight: 800,
                                fontSize: '1rem',
                                color: '#0F172A',
                            }}
                        >
                            {cfg.label}s
                        </Typography>
                    </Box>

                    <IconButton onClick={() => onClose()}>
                        <CloseIcon />
                    </IconButton>
                </Box>

                {/* Table Header */}
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        px: 1,
                        mb: 1.5,
                        pb: 1,
                        borderBottom: '1px dashed #E2E8F0',
                    }}
                >
                    <Typography
                        sx={{
                            fontSize: '0.72rem',
                            fontWeight: 700,
                            letterSpacing: '0.8px',
                            textTransform: 'uppercase',
                            color: '#94A3B8',
                        }}
                    >
                        Event
                    </Typography>

                    <Typography
                        sx={{
                            fontSize: '0.72rem',
                            fontWeight: 700,
                            letterSpacing: '0.8px',
                            textTransform: 'uppercase',
                            color: '#94A3B8',
                        }}
                    >
                        Date
                    </Typography>
                </Box>

                {/* Rows */}
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.1 }}>

                   {rows.length === 0 ? (

    <Box
        sx={{
            py: 6,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        }}
    >
        <Typography
            sx={{
                fontSize: '0.9rem',
                color: '#94A3B8',
                fontWeight: 600,
            }}
        >
            No activity found
        </Typography>
    </Box>

) : (

    rows.map((row, i) => (

                        <Fade in timeout={300 + (i * 100)} key={i}>

                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',

                                    px: 1.2,
                                    py: 1.2,

                                    borderRadius: '14px',

                                    background: 'rgba(255,255,255,0.78)',
                                    backdropFilter: 'blur(10px)',

                                    border: `1px solid ${cfg.accent}18`,

                                    boxShadow: `0 6px 18px ${cfg.accent}10`,

                                    transition: 'all 0.25s ease',

                                    '&:hover': {
                                        transform: 'translateY(-2px)',
                                        boxShadow: `0 10px 22px ${cfg.accent}18`,
                                    }
                                }}
                            >

                                <Box
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 1,
                                    }}
                                >

                                    <Box
                                        sx={{
                                            width: 30,
                                            height: 30,
                                            borderRadius: '10px',
                                            background: cfg.softBg,
                                            color: cfg.accent,
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                        }}
                                    >
                                        {cfg.icon}
                                    </Box>

                                    <Typography
                                        sx={{
                                            fontSize: '0.88rem',
                                            fontWeight: 600,
                                            color: '#0F172A',
                                        }}
                                    >
                                        {cfg.label} {i + 1}
                                    </Typography>
                                </Box>

                                {/* <Chip
                                    label={formatActivityDate(row.created_at)}
                                    size="small"
                                    sx={{
                                        height: 24,
                                        borderRadius: '999px',
                                        background: cfg.softBg,
                                        color: cfg.accent,
                                        fontWeight: 700,
                                        fontSize: '0.68rem',
                                    }}
                                /> */}

                                <Box sx={{ textAlign: 'right' }}>

    <Typography
        sx={{
            fontSize: '0.76rem',
            fontWeight: 700,
            color: cfg.accent,
            lineHeight: 1.1,
        }}
    >
        {formatActivityDate(row.created_at)}
    </Typography>

    <Typography
        sx={{
            fontSize: '0.68rem',
            color: '#94A3B8',
            mt: 0.2,
            fontWeight: 500,
        }}
    >
        {new Date(row.created_at).toLocaleTimeString([], {
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
        })}
    </Typography>

</Box>
                            </Box>

                        </Fade>
                     ))
                    )}

                </Box>
            </>
        );
    })()}
</Dialog>
    );
};

export default InsightsHistoryDialog;